import { render, staticRenderFns } from "./TrademarkObjectionToUsYidkStatus.vue?vue&type=template&id=00b1ef05&"
import script from "./TrademarkObjectionToUsYidkStatus.vue?vue&type=script&lang=js&"
export * from "./TrademarkObjectionToUsYidkStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports